<template>
  <el-dialog
    v-drag
    title="邮件发送"
    :visible.sync="dialogVisible"
    width="440px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content" :loading="loading">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
        <el-form-item label="邮箱地址" prop="emails">
          <base-muti-input
            ref="baseMutiInput"
            v-model="form.emails"
            style="width: 320px"
          ></base-muti-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
  <script>
  const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
  import { sendOperationsReportToEmail } from '@/api/home'
  export default {
    components: { BaseMutiInput },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      dateTime: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        form: {
            emails: []
        },
        loading: false,
        rules: {
            emails: [
            { required: true, message: '请输入邮箱', trigger: 'blur' }
          ]
        }
      }
    },
    watch: {},
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      ok(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            sendOperationsReportToEmail({
                dateTime: this.dateTime,
                emails: this.form.emails
            }).then((res) => {
              if (res.success) {
                this.$message.success('发送成功')
                this.$refs.baseMutiInput.reset()
                this.$emit('cancel')
                this.loading = false
              } else {
                this.$message.error(res.errorMessage)
                this.loading = false
              }
            })
          }
        })
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .content {
    width: 320px;
    margin: 0 auto;
  }
  .footers {
    width: 100%;
    display: flex;
    justify-content: center;
    .cancel {
      width: 120px;
      height: 40px;
      background: #eeeeee;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      margin-right: 16px;
      cursor: pointer;
    }
    .ok {
      width: 120px;
      height: 40px;
      background:  rgb(18,88,188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      cursor: pointer;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
  </style>

